import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Header from './components/Header';
import Hero from './components/Hero';
import ScrollingBanner from './components/ScrollingBanner';
import QuemSomos from './components/QuemSomos';
import Portfolio2 from './components/Portfolio2';
import Feedback from './components/Feedback';
import CTAWhatsApp from './components/CTAWhatsApp';
import Footer from './components/Footer';
import ScrollProgress from './components/ScrollProgress';

import './App.css';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-out-cubic',
      once: true,
      offset: 100
    });
  }, []);

  const backgroundStyle = {
    backgroundColor: '#0F0F0F',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed'
  };

  return (
    <div className="App">
      <ScrollProgress />
      <Header />
      <Hero />
      <ScrollingBanner />
      <div className="dark-background-section" style={backgroundStyle}>
        <section className="about-feedback-section">
          <QuemSomos />
          <Portfolio2 />
          <Feedback />
          <CTAWhatsApp />
        </section>
        <Footer />
      </div>
    </div>
  );
}

export default App;